import { useState } from "react";
import Marquee from "react-fast-marquee";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ArrowLeft, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

export default function Clients({ clients }) {
  const testimonials = clients.testimonials || [];
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];

  const next = () => setIdx((idx + 1) % testimonials.length);
  const prev = () => setIdx((idx - 1 + testimonials.length) % testimonials.length);

  return (
    <section id="clientes" className="relative py-28 sm:py-36" data-testid="clients-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal><Overline>{clients.overline}</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display font-medium tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl">
              {clients.title}
            </h2>
          </Reveal>
        </div>

        {t && (
          <Reveal delay={0.15}>
            <div className="mt-14 rounded-3xl border border-white/10 bg-jauja-surface p-8 sm:p-12" data-testid="testimonial-card">
              <Quote className="text-jauja-lime" size={40} />
              <AnimatePresence mode="wait">
                <motion.blockquote
                  key={idx}
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -15 }}
                  transition={{ duration: 0.4 }}
                  className="mt-6 font-display text-xl sm:text-2xl lg:text-3xl leading-snug text-white/90"
                >
                  "{t.quote}"
                </motion.blockquote>
              </AnimatePresence>
              <div className="mt-8 flex items-center justify-between flex-wrap gap-4">
                <div>
                  <div className="font-semibold text-white">{t.name}</div>
                  <div className="text-sm text-jauja-lime">{t.role}</div>
                </div>
                <div className="flex items-center gap-3">
                  <button onClick={prev} data-testid="testimonial-prev" className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white hover:bg-jauja-lime hover:text-jauja-bg hover:border-jauja-lime transition-colors">
                    <ArrowLeft size={18} />
                  </button>
                  <button onClick={next} data-testid="testimonial-next" className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white hover:bg-jauja-lime hover:text-jauja-bg hover:border-jauja-lime transition-colors">
                    <ArrowRight size={18} />
                  </button>
                </div>
              </div>
            </div>
          </Reveal>
        )}
      </div>

      {(clients.logos || []).length > 0 && (
        <div className="mt-16 border-y border-white/10 py-8">
          <Marquee gradient={false} speed={40} pauseOnHover>
            {clients.logos.map((logo, i) => (
              <span key={i} className="mx-10 font-display text-2xl sm:text-3xl font-medium text-white/40 hover:text-jauja-lime transition-colors" data-testid="client-logo">
                {logo}
              </span>
            ))}
          </Marquee>
        </div>
      )}
    </section>
  );
}
